var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action, computed } from 'mobx';
import ConnectorResults from './connectorResults';
import ConnectorResult from './connectorResult';
export { ConnectorResults, ConnectorResult };
export default class Connector {
    options = {};
    _pendingRequestCount = 0;
    constructor(options = {}) {
        this.options = options;
        this.initialize(options);
    }
    get isLoading() {
        return this._pendingRequestCount > 0;
    }
    initialize(options) {
        // To override
    }
    list(collection, options = {}) {
        return Promise.reject(new Error('Connector "list" method not implemented'));
    }
    fetch(model, options = {}) {
        return Promise.reject(new Error('Connector "fetch" method not implemented'));
    }
    save(model, options = {}) {
        return Promise.reject(new Error('Connector "save" method not implemented'));
    }
    destroy(model, options = {}) {
        return Promise.reject(new Error('Connector "destroy" method not implemented'));
    }
    onConnect() {
        this._pendingRequestCount++;
    }
    onDisconnect() {
        this._pendingRequestCount--;
    }
}
__decorate([
    observable
], Connector.prototype, "_pendingRequestCount", void 0);
__decorate([
    computed
], Connector.prototype, "isLoading", null);
__decorate([
    action
], Connector.prototype, "onConnect", null);
__decorate([
    action
], Connector.prototype, "onDisconnect", null);
//# sourceMappingURL=connector.js.map